import { logWrapper } from '../utils';

export default [
  'runtimeConstant',
  '$qProvider',
  function (runtimeConstant, $qProvider) {
    function run() {
      try {
        /*
          O serviço $q (que pode ser configurado através do $qProvider) é a implementação de promise
          no AngularJS (https://www.geeksforgeeks.org/angularjs-qprovider). Por padrão, quando uma promise
          rejeitada não for tratada, um erro é gerado.

          Existe um bug (https://github.com/angular-ui/ui-router/issues/3246) na biblioteca angular-ui-router
          que gera a mensagem 'Error: transition superseded' na console do navegador, e atrapalha na investigação
          de outros erros. Para suprimir esse erro basta alterar o comportamento padrão do $q utilizando
          $qProvider.errorOnUnhandledRejections(false)
      */
        $qProvider.errorOnUnhandledRejections(false);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    // Wrap the setup function with logWrapper for debugging purposes
    logWrapper(run, runtimeConstant.isDebugConfigs)();
  },
];
